import { useComments } from '@/hooks/api/comments';
import { Skeleton, Stack, Typography } from '@mui/material';
import CommentCard from './CommentCard';

const PinnedComments = ({
  type = 'course',
  id,
  handleRefetchData,
  courseOwner = false,
  blogOwner = false,
}) => {
  const { data, isLoading, error, isError, refetch } = useComments({
    // limit,
    // currentPage: pageIndex,
    post: id,
    ...(type === 'blog' && { pinToBlog: true }),
    ...(type === 'course' && { pinToCourse: true }),
    ...(type === 'lesson' && { pinToCourse: true }),
  });

  if (isLoading || isError) {
    return (
      <>
        {isLoading ? (
          <Skeleton variant="rounded" height={100} />
        ) : (
          <Typography>خطا در دریافت اطلاعات</Typography>
        )}
      </>
    );
  }

  return (
    <>
      {data.totalResults > 0 ? (
        <>
          <Typography fontSize={24} fontWeight={500} color="text.secondary">
            {type === 'course' || type === 'blog'
              ? 'نظرات برتر'
              : 'سوالات پرتکرار'}
          </Typography>
          <Stack spacing={3} mt={4}>
            {data.results?.map((item, index) => (
              <CommentCard
                key={index}
                comment={item}
                id={id}
                handleRefetchData={handleRefetchData}
                type={type}
                pinned
                courseOwner={courseOwner}
                blogOwner={blogOwner}
                maxPinCount={
                  type === 'blog'
                    ? data.generalInfo?.blog?.maxComment
                    : data.generalInfo?.course?.maxComment
                }
                canPin={
                  type === 'blog'
                    ? data.generalInfo?.blog?.countOfComment <
                      data.generalInfo?.blog?.maxComment
                    : data.generalInfo?.course?.countOfComment <
                      data.generalInfo?.course?.maxComment
                }
              />
            ))}
          </Stack>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default PinnedComments;
